module.exports = __webpack_public_path__ + "media/images/ticket/continue shopping-c3ebdba03aeae5f4bffc408dcae28317.png";